import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import { useVehicle } from "../context/VehicleContext";
export default function CategoryPage() {
  const { categoryName } = useParams();

 const [listings, setListings] = useState([]);
const { selectedVehicle, vehicleLoaded } = useVehicle();

useEffect(() => {
  if (!vehicleLoaded) return;
  let url = "https://eleven11-i6v4.onrender.com/api/listings";
  if (selectedVehicle) {
    const params = new URLSearchParams({
      year: selectedVehicle.year,
      manufacturer: selectedVehicle.manufacturer,
      model: selectedVehicle.model
    });
    url += `?${params.toString()}`;
  }
  fetch(url)
    .then(res => res.json())
    .then(data => setListings(data))
    .catch(err => console.error(err));
}, [selectedVehicle, vehicleLoaded]);

const categoryMap = {
  "marine-detailing": "Marine Detailing",
  "lubricants": "Lubricants & Sprays",
  "accessories": "Accessories",
  "electronics": "Electronics",
  "new-oem": "New OEM Parts",
  "used-oem": "Used OEM Parts",
  "fluids": "Fluids & Maintenance"
};

const mappedCategory =
  categoryMap[categoryName];

const filtered = listings.filter((l) => {

  if (categoryName === "used-oem") {
    return l.condition === "used";
  }

  if (categoryName === "new-oem") {
    return l.condition === "new";
  }

  return l.category === mappedCategory;
});


  const styles = {  
    page: {
      background: "#F6F7FB",
      minHeight: "100vh",
      fontFamily: "Inter, sans-serif"
    },
    container: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "30px 20px"
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
      gap: "20px",
      marginTop: "20px"
    },
    title: {
      fontSize: "26px",
      fontWeight: 600
    }
  };



const displayName = categoryMap[categoryName] || categoryName;



  return (
    <div style={styles.page}>
 

      <div style={styles.container}>
      <div style={styles.title}>{displayName}</div>

        <div style={styles.grid}>
   {filtered.map((item) => {
  const displayPrice = item.variants?.length
    ? Math.min(...item.variants.map(v => v.price))
    : item.price || 0;
  return (
    <ProductCard
      key={item._id}
      id={item._id}
      title={item.title}
      price={displayPrice}
      image={
        item.variants?.find(v => v.condition === "used")?.images?.[0] ||
        item.variants?.find(v => v.condition === "new")?.images?.[0] ||
        item.images?.[0] ||
        undefined
      }
      unitsAvailable={item.unitsAvailable}
      delivery={item.delivery}
      fastest={item.fastest}
    />
  );
})}
        </div>
      </div>
    </div>
  );
}